import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=c514d212&scoped=true&"
import script from "./Open.vue?vue&type=script&lang=ts&"
export * from "./Open.vue?vue&type=script&lang=ts&"
import style0 from "./Open.vue?vue&type=style&index=0&id=c514d212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c514d212",
  null
  
)

export default component.exports